/* eslint-disable max-statements */
/* eslint-disable complexity */
import formatData from '@/mixins/formatData';

export default {
    name: 'PositionStates',

    mixins: [formatData],

    /**
     * @override
     */
    data() {
        return {
            positionStatesTable: {},
            collapsed: true
        };
    },
    props: {
        data: {
            type: Array,
            required: false
        },
        loading: {
            type: Boolean,
            required: false
        }
    },
    watch: {
        /**
         * Actualizar registro de la tabla ante cambios en data
         */
        data() {
            this.formatData();
        }
    },
    methods: {
        /**
         * Formatea el objeto data
         */
        formatData() {
            if (!this.data || !Array.isArray(this.data) || this.data.length < 1) {
                this.$set(this.positionStatesTable, 'items', []);
                return;
            }
            this.$set(this.positionStatesTable, 'items', this.data.map(i => i));
        },

        onRowSelected(item) {
            this.$router.push({
                name: 'accounts_uuid_view',
                query: { name: item.account, view: 'accounts-details', id: item.account_uuid },
                params: { uuid: item.account_uuid }
            });
        }
    },
    /**
     * @override
     */
    beforeMount() {
        this.positionStatesTable = {
            fields: [
                { key: 'account', label: 'Cuenta', tdClass: 'color-brand' },
                { key: 'intervener_role', label: 'Rol' },
                { key: 'current_amount', label: 'Valoración' },
                { key: 'purchase_amount', label: 'Importe Compra' },
                { key: 'difference', label: 'Diferencia' },
                { key: 'profitability', label: 'Rentabilidad' }
            ]
        };
    }
};
